export default __webpack_public_path__ + "static/media/f05.10c1cc48.svg";